import { Slider, SliderProps, styled } from "@mui/material";

const StyledSlider = styled(Slider)<SliderProps>(({ theme }) => ({
    "& .MuiSlider-rail": {
        border: "none",
        backgroundColor: "#838280",
    },
    "& .MuiSlider-thumb": {
        height: 20,
        width: 20,
        backgroundColor: "#fff",
        border: "2px solid currentColor",
        "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
            boxShadow: "inherit",
        },
        "&:before": {
            display: "none",
        },
    },
    "& .MuiSlider-valueLabel": {
        color: theme.palette.primary.main,
        lineHeight: "16.5px",
        fontSize: 12,
        background: "unset",
        fontWeight: 500,
        fontFamily: "var(--font-mono)",
        fontVariantNumeric: "tabular-nums",
        top: "-5px",
        backgroundColor: "rgba(131, 130, 128, 0.05)",
        "&:before": { display: "none" },
    },
}));

type OwnProps = {
    max: number;
    min: number;
    value: number | number[];
    onChange: (event: Event, value: number | number[], activeThumb: number) => void;
};

export const CustomSlider = ({ max, min, value, onChange }: OwnProps) => {
    const onChangeHandle = (event: Event, value: number | number[], activeThumb: number) => {
        onChange(event, value, activeThumb);
    };

    return <StyledSlider max={max} min={min} value={value} valueLabelDisplay="on" onChange={onChangeHandle} />;
};
